export default __webpack_public_path__ + "static/media/lock.4c1a0b5e.svg";